export enum CalculationType {
  BASIC = 'basic',
  ADJUSTED = 'adjusted'
}
